import {
  GET_USER_LOGS_FAILURE,
  GET_USER_LOGS_REQUEST,
  GET_USER_LOGS_SUCCESS,
  GET_USER_LOGS_BY_USER_ID_REQUEST,
  GET_USER_LOGS_BY_USER_ID_SUCCESS,
  GET_USER_LOGS_BY_USER_ID_FAILURE,
  GET_USER_LOGS_BY_IP_REQUEST,
  GET_USER_LOGS_BY_IP_SUCCESS,
  GET_USER_LOGS_BY_IP_FAILURE,
} from "./ActionType";

const initialState = {
  loadingUserLogs: false,
  errorUserLogs: null,
  userLogs: null,
};

export const userLogReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_LOGS_REQUEST:
    case GET_USER_LOGS_BY_USER_ID_REQUEST:
    case GET_USER_LOGS_BY_IP_REQUEST:
      return {
        ...state,
        loadingUserLogs: true,
        errorUserLogs: null,
      };
    case GET_USER_LOGS_SUCCESS:
    case GET_USER_LOGS_BY_USER_ID_SUCCESS:
    case GET_USER_LOGS_BY_IP_SUCCESS:
      return {
        ...state,
        loadingUserLogs: false,
        userLogs: action.payload,
        errorUserLogs: null,
      };
    case GET_USER_LOGS_FAILURE:
    case GET_USER_LOGS_BY_USER_ID_FAILURE:
    case GET_USER_LOGS_BY_IP_FAILURE:
      return {
        ...state,
        loadingUserLogs: false,
        errorUserLogs: action.payload,
      };
    default:
      return state;
  }
};

